import { Accordion, Anchor, Box, Drawer, ScrollArea, Text, Title } from '@mantine/core'
import React from 'react'

import { Contract as ContractType, ProductTypes, SimplePayment as SimplePaymentType } from '@/types'

import { PaymentsCalendar } from '.'

interface Props {
  type: ProductTypes
  payments: SimplePaymentType[]
  contracts: ContractType[]
  opened: boolean
  handlePaymentsDrawerOpen: (open: boolean) => void
  buyButtons: React.ReactNode
}

export default function PaymentDrawer({
  type,
  payments,
  contracts,
  opened,
  handlePaymentsDrawerOpen,
  buyButtons
}: Props) {
  return (
    <Drawer
      opened={opened}
      onClose={() => handlePaymentsDrawerOpen(false)}
      padding="sm"
      size="lg"
      position="right"
      title={<Title order={3}>Pagamentos</Title>}>
      {buyButtons && <Box mb="sm">{buyButtons}</Box>}
      <Text size="sm" mb="xs">
        Calendário de pagamentos
      </Text>
      <ScrollArea style={{ height: 'calc(100vh - 200px)' }}>
        {type === 'tuition' && <PaymentsCalendar payments={payments} />}
        {(type === 'contract' || type === 'kit') &&
          (contracts.length > 0 ? (
            <Accordion variant="contained">
              {contracts.map(contract => (
                <Accordion.Item key={contract.uid} value={contract.uid}>
                  <Accordion.Control p="xs">
                    <Text size="sm">
                      {contract.label}
                      <Text span size="sm" hidden={!contract?.agreement}>
                        {' / '}
                        <Anchor
                          size="sm"
                          href={contract?.agreement}
                          rel="noreferrer noopener"
                          target="_blank">
                          Visualizar termos
                        </Anchor>
                      </Text>
                    </Text>
                  </Accordion.Control>
                  <Accordion.Panel>
                    <PaymentsCalendar payments={contract.payments} />
                  </Accordion.Panel>
                </Accordion.Item>
              ))}
            </Accordion>
          ) : (
            <PaymentsCalendar payments={payments} />
          ))}
      </ScrollArea>
    </Drawer>
  )
}
